
<template>
    <a :href="[item.Url]" v-for="item in socialmedialinkList"  target="_blank" :title="item.Title"><i :class="[item.IconUsed]"></i></a>   
</template>
<script>
    export default {
        props: ["companyName", "schema", "socialmedialinkList"],
    }
</script>